import { SupportedLocale } from "@/i18n";
import { MergedDisplayData } from "./types";

interface ArtworkOverviewProps {
  displayData: MergedDisplayData;
  locale: SupportedLocale;
  itemType: "ARTWORK" | "PHOTO_MASTER" | "TIRAGE";
  t: (key: string, options?: any) => string;
  overviewSummaryCalculated: string;
}

export function ArtworkOverview({
  displayData,
  locale,
  itemType,
  t,
  overviewSummaryCalculated,
}: ArtworkOverviewProps) {
  return (
    <div className="mb-1">
      <div className="font-normal text-sm">
        <div
          dangerouslySetInnerHTML={{
            __html: overviewSummaryCalculated,
          }}
          className="subpixel-antialiased"
        />
      </div>
      <div className="my-1 subpixel-antialiased">
        {displayData?.oeuvresDescriptionSousTitre && (
          <p className="font-normal text-sm">
            {t("singleArtworkSubtitleSousTitre") +
              " " +
              displayData.oeuvresDescriptionSousTitre}
          </p>
        )}
        {displayData?.oeuvresDescriptionAutreTitre && (
          <p className="font-normal text-sm">
            {t("singleArtworkSubtitleAutreTitre") +
              " " +
              displayData.oeuvresDescriptionAutreTitre}
          </p>
        )}
        {displayData?.oeuvresDescriptionReference && (
          <p className="font-normal text-sm">
            {t("singleArtworkSubtitleReference") +
              " " +
              displayData.oeuvresDescriptionReference}
          </p>
        )}
      </div>
      {/* For ARTWORK (not PHOTO_MASTER, not TIRAGE): always show public notes if available */}
      {itemType !== "PHOTO_MASTER" &&
        itemType !== "TIRAGE" &&
        displayData?.oeuvresValidationRemarquesPubliquesMultilingual?.[
          locale
        ] && (
          <div className="my-1 mt-4 flex flex-col gap-4 font-medium text-sm subpixel-antialiased">
            {t("singleArtworkSubtitlePublicNote", { count: 0 })}
            <div
              dangerouslySetInnerHTML={{
                __html:
                  displayData?.oeuvresValidationRemarquesPubliquesMultilingual[
                    locale
                  ],
              }}
              className="font-normal text-sm subpixel-antialiased"
            />
          </div>
        )}
    </div>
  );
}
